// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
  textSemiBold,
} from './css';
import { Text2 } from './Text';

export const Text2Normal = styled(Text2)`
  ${textNormal};
`;

export const Text2Black = styled(Text2)`
  ${textBlack};
`;

export const Text2Bold = styled(Text2)`
  ${textBold};
`;
export const Text2SemiBold = styled(Text2)`
  ${textSemiBold};
`;

export const Text2BoldLoose = styled(Text2)`
  ${textBoldLoose};
`;
